<template>
  <div>
    <div>
      <router-link :to="{ name: 'createRoomUserList' }">
        <el-button type="primary">开房权限列表</el-button>
      </router-link>
      <router-link :to="{ name: 'restrictedLoginList' }">
        <el-button style="margin-left: 10px" type="primary" plain>限制登录列表</el-button>
      </router-link>
      <div class="common-search">
        <el-input
          v-model="searchVal"
          class="common-el-input"
          @keyup.enter="getList()"
          placeholder="请输入玩家ID或昵称进行查询"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="getList()">搜索</el-button>
      </div>
    </div>
    <div>
      <strong class="common-text-item" v-text="`玩家总数：${userList.total}`"></strong>
    </div>
    <div>
      <el-button type="success" @click="addIPConfigFunc">添加登录限制</el-button>
    </div>
    <div class="common-table">
      <el-table
        v-loading="loading"
        :data="userList.beanList"
        row-key="randomId"
        height="100%"
        @selection-change="selection = $event"
      >
        <el-table-column align="center" type="selection" width="55" />
        <el-table-column label="编号" type="index" align="center" />
        <el-table-column label="用户ID" min-width="120" align="center" prop="userId">
        </el-table-column>
        <el-table-column label="用户昵称" min-width="150" align="center" prop="nickName" />
        <el-table-column label="用户旧昵称" min-width="150" align="center" prop="oldNickName" />
        <el-table-column label="用户标签" min-width="150" align="center">
          <template slot-scope="scope">
            <!--                    {{scope.row.userLabel}}-->
            <select-set-value
              class="select-set-value"
              :list="userLabelOptions"
              :text="scope.row.userLabel"
              @my-submit="updateLabelFunc($event, scope.row.userId)"
            />
          </template>
        </el-table-column>

        <el-table-column label="俱乐部" min-width="180" align="center" prop="clubName" />
        <el-table-column label="可提/不可提/金豆数" min-width="250" align="center">
          <template slot-scope="scope">
            {{ scope.row.canExtractChip / 100 }}/{{ scope.row.notExtractChip / 100 }}/{{
              scope.row.chip / 100
            }}
          </template>
        </el-table-column>
        <el-table-column label="玩家身份" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.userType | userTypeName }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" min-width="150" align="center" prop="phone" />
        <el-table-column label="钱包状态" align="center" width="150">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.walletStatus"
              :active-value="1"
              :inactive-value="2"
              inactive-color="red"
              active-text="正常"
              inactive-text="停用"
              @change="showMsgCodeFunc('walletStatus', scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column label="账户状态" align="center" width="150">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.statu"
              :active-value="1"
              :inactive-value="0"
              inactive-color="red"
              active-text="启用"
              inactive-text="冻结"
              @change="showMsgCodeFunc('statu', scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column label="登录状态" align="center" width="150">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.loginStatus"
              :active-value="1"
              :inactive-value="0"
              inactive-color="red"
              active-text="正常"
              inactive-text="禁登"
              @change="showMsgCodeFunc('loginStatus', scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column label="用户详细记录" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="rowClick(scope.row)"
              >用户详细记录</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="addFunc(scope.row)"
              >添加开房权限</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="注册时间" min-width="180" align="center" prop="regTime" />
      </el-table>
    </div>
    <el-pagination
      class="common-el-pagination"
      layout="prev,pager,next,jumper"
      background
      :page-size="20"
      :pager-count="5"
      :total="userList.total"
      :current-page="currentPage"
      @current-change="getList($event)"
    />

    <div v-if="showMsgCode" class="common-popup-bg">
      <div class="common-popup">
        <h3>谷歌验证</h3>
        <table class="common-popup-table">
          <tr>
            <td>
              <el-input placeholder="请输入谷歌验证码" v-model="code"></el-input>
            </td>
          </tr>
        </table>
        <footer>
          <el-button size="small" @click="closeMsgCode">取消</el-button>
          <el-button size="small" @click="submitMsgCode" type="primary">确定 </el-button>
        </footer>
      </div>
    </div>

    <div v-show="showIPConfig" class="common-popup-bg">
      <div class="common-popup">
        <h3>指定玩家登录设备码设置</h3>
        <div style="padding: 20px 30px">
          <el-input
            type="textarea"
            rows="4"
            resize="none"
            v-model="imeiSet"
            style="width: 280px"
            placeholder="请输入"
          ></el-input>
        </div>
        <footer>
          <el-button size="small" @click="showIPConfig = false">取消</el-button>
          <el-button size="small" type="primary" @click="submitIPConfig">确定</el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import selectSetValue from 'components/selectSetValue';

export default {
  components: {
    selectSetValue,
  },
  data() {
    return {
      loading: false,
      searchVal: '',
      selection: [],
      currentPage: 1,
      configOp: '',
      configUserId: '', // 将要修改状态的玩家id
      configRandomId: '', // 将要修改状态的玩家显性id
      code: '', //短信
      showMsgCode: false, //显示发送短信弹窗
      updateType: '', //钱包：walletStatus 账户：statu
      showIPConfig: false,
      imeiSet: '', // 机器码
    };
  },
  computed: {
    ...mapGetters('user', ['userLabelOptions']),
    ...mapState('user', ['userList']),
  },
  created() {
    this.getUserLabelList();
    this.getList();
  },
  methods: {
    ...mapActions('user', [
      'getUserLabelList',
      'getUserList',
      'openCreateRoomOp',
      'updateUserState',
      'updateWalletClose',
      'updateWalletOpen',
      'addUserImeiLogin',
      'setLoginAllow',
      'setLoginForbid',
      'setUserAddLabel',
    ]),
    ...mapActions('other', ['sendCodeToMyPhone']),
    rowClick(row) {
      const id = row.randomId;
      this.$router.push({ name: 'integralUser', params: { id: id } });
    },
    updateLabelFunc({ value, cb }, userId) {
      if (value) {
        this.setUserAddLabel({
          labelConfigId: value,
          userId,
        }).then(() => {
          cb();
          this.$message.success('修改成功');
          this.getList(this.currentPage);
        });
      } else {
        this.$message.error('标签不能为空');
      }
    },
    rowUserLabel(val) {
      if (val === null || val === '') {
        return '-';
      } else return val;
    },
    getList(page = 1) {
      this.loading = true;
      this.currentPage = page;
      this.getUserList({
        content: this.searchVal,
        page,
      }).then(() => {
        this.loading = false;
      });
    },
    // 设置开房权限
    addFunc(row) {
      this.$confirm('您确认给选中玩家开放“开房权限”功能，开放后玩家可在APP端拥有开局功能', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.openCreateRoomOp(row.randomId).then(() => {
            this.$message.success('成功添加开房权限');
          });
        })
        .catch(() => {});
    },
    // 发送短信
    sendCodeFunc(e) {
      let type = 3; // 账户状态
      switch (this.updateType) {
        case 'walletStatus':
          if (this.configOp === 1) {
            type = 15; // 启用钱包
          } else {
            type = 14; // 冻结钱包
          }
          break;
        case 'loginStatus':
          if (this.configOp === 1) {
            type = 21; // 允许登录
          } else {
            type = 20; // 禁止登录
          }
          break;
        default:
          break;
      }
      this.sendCodeToMyPhone({ err: e.err, type });
    },
    showMsgCodeFunc(type, row, value) {
      this.updateType = type;
      this.configUserId = row.userId;
      this.configRandomId = row.randomId;
      this.configOp = value;
      this.showMsgCode = true;
    },
    submitMsgCode() {
      if (!this.code) {
        this.$message.error('请输入谷歌验证码');
        return;
      }
      switch (this.updateType) {
        case 'loginStatus':
          if (this.configOp === 1) {
            // 允许登录
            this.setLoginAllow({
              smsCode: this.code,
              userId: this.configUserId,
            }).then(() => {
              this.getList(this.currentPage);
              this.$message.success('请求成功');
              this.closeMsgCode();
            });
          } else {
            // 禁止登录
            this.setLoginForbid({
              smsCode: this.code,
              userId: this.configUserId,
            }).then(() => {
              this.getList(this.currentPage);
              this.$message.success('请求成功');
              this.closeMsgCode();
            });
          }
          break;
        case 'statu':
          // 需改账户状态
          this.updateUserState({
            code: this.code,
            op: this.configOp,
            userId: this.configRandomId,
          }).then(() => {
            this.getList(this.currentPage);
            this.$message.success('请求成功');
            this.closeMsgCode();
          });
          break;
        case 'walletStatus':
          // 钱包状态
          if (this.configOp === 1) {
            // 启用钱包
            this.updateWalletOpen({
              smsCode: this.code,
              userId: this.configUserId,
            }).then(() => {
              this.getList(this.currentPage);
              this.$message.success('请求成功');
              this.closeMsgCode();
            });
          } else {
            // 冻结钱包
            this.updateWalletClose({
              smsCode: this.code,
              userId: this.configUserId,
            }).then(() => {
              this.getList(this.currentPage);
              this.$message.success('请求成功');
              this.closeMsgCode();
            });
          }
          break;
        default:
          break;
      }
    },
    closeMsgCode() {
      this.configUserId = '';
      this.configRandomId = '';
      this.code = '';
      this.showMsgCode = false;
    },
    addIPConfigFunc() {
      if (!this.selection.length) {
        this.$message.info('请先选择您要设置的玩家');
        return;
      }
      this.showIPConfig = true;
    },
    // 添加登录限制
    submitIPConfig() {
      this.addUserImeiLogin({
        imeiSet: this.imeiSet.split(','),
        userIdSet: this.selection.map((item) => {
          return item.userId;
        }),
      }).then(() => {
        this.$message.success('添加成功');
        this.imeiSet = '';
        this.showIPConfig = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-expand {
  .item {
    display: inline-block;
    padding: 2px 20px;
  }
}

.select-set-value {
  :global(.el-input) {
    width: 150px !important;
  }
}
</style>
